import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddEventLinkedUserMutationVariables = Types.Exact<{
  payload: Types.EventLinkedUserInput;
}>;


export type AddEventLinkedUserMutation = { __typename?: 'Mutation', addEventLinkedUser: Array<{ __typename?: 'EventLinkedUser', id: string }> };


export const AddEventLinkedUserDocument = gql`
    mutation AddEventLinkedUser($payload: EventLinkedUserInput!) {
  addEventLinkedUser(payload: $payload) {
    id
  }
}
    `;
export type AddEventLinkedUserMutationFn = Apollo.MutationFunction<AddEventLinkedUserMutation, AddEventLinkedUserMutationVariables>;

/**
 * __useAddEventLinkedUserMutation__
 *
 * To run a mutation, you first call `useAddEventLinkedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventLinkedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventLinkedUserMutation, { data, loading, error }] = useAddEventLinkedUserMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAddEventLinkedUserMutation(baseOptions?: Apollo.MutationHookOptions<AddEventLinkedUserMutation, AddEventLinkedUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEventLinkedUserMutation, AddEventLinkedUserMutationVariables>(AddEventLinkedUserDocument, options);
      }
export type AddEventLinkedUserMutationHookResult = ReturnType<typeof useAddEventLinkedUserMutation>;
export type AddEventLinkedUserMutationResult = Apollo.MutationResult<AddEventLinkedUserMutation>;
export type AddEventLinkedUserMutationOptions = Apollo.BaseMutationOptions<AddEventLinkedUserMutation, AddEventLinkedUserMutationVariables>;